export default __webpack_public_path__ + "27dd01909265684d3e1a109976a867fa.jpg";